import React from 'react';
import { SuiContainer, SuiLabel } from '@splashthat/sui';

import SecondaryButtonBackgroundPanel from './SecondaryButtonBackgroundPanel';
import SecondaryButtonBorderPanel from './SecondaryButtonBorderPanel';
import SecondaryButtonTextPanel from './SecondaryButtonTextPanel';
import { BUTTON_COLOR_LABEL, BUTTON_TEXT_LABEL } from '../../../../constants/formStyleLabels';
import { COLLAPSIBLE_CONTENT, COLLAPSIBLE_SECTION } from '../../../../constants/reusableClassNames';
import { SECONDARY_BUTTON_QA } from '../../../../utils/qaIdConstants';

/** @var {Object} - section components and labels ordered. */
const SECTION_PANELS = [
    {
        panel: <SecondaryButtonBackgroundPanel />,
        label: BUTTON_COLOR_LABEL,
        qaId: 'secondaryButtonColor',
    },
    {
        panel: <SecondaryButtonTextPanel />,
        label: BUTTON_TEXT_LABEL,
        qaId: 'secondaryButtonText',
    },
    {
        panel: <SecondaryButtonBorderPanel />,
        qaId: 'border',
    },
];

const FormStyleEditorSecondaryButtonPanel = () => (
    <SuiContainer className={COLLAPSIBLE_CONTENT} data-qa={`${SECONDARY_BUTTON_QA}--panel`}>
        {SECTION_PANELS.map(({ panel, label, qaId }, index) => (
            <SuiContainer
                key={index}
                className={COLLAPSIBLE_SECTION}
                data-qa={`${SECONDARY_BUTTON_QA}--section-${qaId}`}
            >
                {label ? <SuiLabel text={label} data-qa={`${SECONDARY_BUTTON_QA}--label`} /> : null}
                {panel}
            </SuiContainer>
        ))}
    </SuiContainer>
);

export default FormStyleEditorSecondaryButtonPanel;
